// extracted by mini-css-extract-plugin
module.exports = {"view-item-video":"view-item-video_view-item-video__1WNqX","viewItemVideo":"view-item-video_view-item-video__1WNqX"};